//学生保险


import { GET, POST, POSTNEW, EXPORTNEW, download, POSTFormDataNEW} from '@/request/http'
//分页查询数据
export const studentInquire = p => POST('/studentgrowthfiles/studentInsuranceInfo/queryPage', p)
//删除保险档案
export const studentDelete = p => POST('/studentgrowthfiles/studentInsuranceInfo/delete', p)
//根据ID查询保险档案
export const studentIdInquire = p => POST('/studentgrowthfiles/studentInsuranceInfo/queryById', p)
//新增保险档案页搜索
export const studentInsertStudentInfo = p => POST('/studentgrowthfiles/studentInsuranceInfo/insertWithStudentInfo', p)
//根据ID更新保险档案
export const studentUpdate = p => POST('/studentgrowthfiles/studentInsuranceInfo/update', p)
//导出保险档案
export const studentExport = p => EXPORTNEW('/studentgrowthfiles/studentInsuranceInfo/export', p)
//导出学生保险信息导入模板
export const studentExportTemplate = p => EXPORTNEW('/studentgrowthfiles/studentInsuranceInfo/template', p)
//导入保险档案
export const studentImport = p => POSTFormDataNEW('/studentgrowthfiles/studentInsuranceInfo/import', p)
//新增保险档案
export const studentInsert = p => POST('/studentgrowthfiles/studentInsuranceInfo/insert', p)


//哈尔滨银行贷款


//新增本地行贷款档案
export const HBstudentInsert = p => POST('/studentgrowthfiles/localLoanInfo/insert', p)
//新增本地行贷款档案,学生相关信息根据学生NO查询
export const HBstudentInsertStudentInfo = p => POST('/studentgrowthfiles/localLoanInfo/insertWithStudentInfo', p)
//根据ID更新本地行贷款档案
export const HBstudentUpdate = p => POST('/studentgrowthfiles/localLoanInfo/update', p)
//删除本地行贷款档案
export const HBstudentDelete = p => POST('/studentgrowthfiles/localLoanInfo/delete', p)
//根据ID查询本地行贷款档案
export const HBstudentIdInquire = p => POST('/studentgrowthfiles/localLoanInfo/queryById', p)
//下载本地行贷款档案导出模板
export const HBstudentExportTemplate = p => EXPORTNEW('/studentgrowthfiles/localLoanInfo/template', p)
//导出地行贷款档案
export const HBstudentExport = p => EXPORTNEW('/studentgrowthfiles/localLoanInfo/export', p)
//导入地行贷款档案
export const HBstudentImport = p => POSTFormDataNEW('/studentgrowthfiles/localLoanInfo/import', p)
//分页查询本地行贷款档案
export const HBstudentInquire = p => POST('/studentgrowthfiles/localLoanInfo/queryPage', p)




//国开行贷款

//新增本地行贷款档案
export const CDBstudentInsert = p => POST('/studentgrowthfiles/cdbLoanInfo/insert', p)
//新增本地行贷款档案,学生相关信息根据学生NO查询
export const CDBstudentInsertStudentInfo = p => POST('/studentgrowthfiles/cdbLoanInfo/insertWithStudentInfo', p)
//根据ID更新本地行贷款档案
export const CDBstudentUpdate = p => POST('/studentgrowthfiles/cdbLoanInfo/update', p)
//删除本地行贷款档案
export const CDBstudentDelete = p => POST('/studentgrowthfiles/cdbLoanInfo/delete', p)
//根据ID查询本地行贷款档案
export const CDBstudentIdInquire = p => POST('/studentgrowthfiles/cdbLoanInfo/queryById', p)
//下载本地行贷款档案导出模板
export const CDBstudentExportTemplate = p => EXPORTNEW('/studentgrowthfiles/cdbLoanInfo/template', p)
//导出地行贷款档案
export const CDBstudentExport = p => EXPORTNEW('/studentgrowthfiles/cdbLoanInfo/export', p)
//导入地行贷款档案
export const CDBstudentImport = p => POSTFormDataNEW('/studentgrowthfiles/cdbLoanInfo/import', p)
//分页查询本地行贷款档案
export const CDBstudentInquire = p => POST('/studentgrowthfiles/cdbLoanInfo/queryPage', p)

//传给后端审核的数组
export const addToExamineStatus = p => POST('/studentgrowthfiles/outstandingGraduates/addToExamineStatus', p)

      



// WEBPACK FOOTER //
// ./src/api/modules/studentInsurance.js